var HeaderDataTestIdEnum = /* @__PURE__ */ ((HeaderDataTestIdEnum2) => {
  HeaderDataTestIdEnum2["HEADER_USER_BUTTON"] = "header--user-button";
  HeaderDataTestIdEnum2["HEADER_LOGIN_BUTTON"] = "header--login-button";
  HeaderDataTestIdEnum2["HEADER_PROFILE_LOADING"] = "header--profile-loading";
  HeaderDataTestIdEnum2["HEADER_LOGIN_LOADING"] = "header--login-loading";
  HeaderDataTestIdEnum2["HEADER_I_WANT_TO_ORDER_BUTTON"] = "header--i-want-to-order-button";
  HeaderDataTestIdEnum2["HEADER_OUR_BRANCHES_BUTTON"] = "header--our-branches-button";
  HeaderDataTestIdEnum2["HEADER_FOR_YOU_NAVBAR_TITLE"] = "header--for-you-navbar-title";
  HeaderDataTestIdEnum2["HEADER_PROFESSIONAL_NAVBAR_TITLE"] = "header--professional-navbar-title";
  HeaderDataTestIdEnum2["HEADER_ABOUT_MEDPREV_NAVBAR_TITLE"] = "header--about-medprev-navbar-title";
  HeaderDataTestIdEnum2["HEADER_PARTNER_SYSTEM_LINK"] = "header--partner-system-link";
  HeaderDataTestIdEnum2["HEADER_BE_OUR_PARTNER_LINK"] = "header--be-our-partner-link";
  HeaderDataTestIdEnum2["HEADER_ABOUT_US_LINK"] = "header--about-us-link";
  HeaderDataTestIdEnum2["HEADER_NEED_HELP_LINK"] = "header--need-help-link";
  HeaderDataTestIdEnum2["HEADER_NEED_HELP_BUTTON"] = "header--need-help-button";
  HeaderDataTestIdEnum2["HEADER_BLOG_LINK"] = "header--blog-link";
  HeaderDataTestIdEnum2["HEADER_WORK_WITH_US_LINK"] = "header--work-with-us-link";
  HeaderDataTestIdEnum2["HEADER_LINK_LOGO"] = "header--link-logo";
  HeaderDataTestIdEnum2["HEADER_HUMBURGER_BUTTON"] = "hamburger-button";
  return HeaderDataTestIdEnum2;
})(HeaderDataTestIdEnum || {});
export {
  HeaderDataTestIdEnum
};
